export default __webpack_public_path__ + "static/media/mb1.c888b16c.JPG";